import React, { Component } from "react";
import Header from "../Header/Header";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import Moment from "moment";
import Url from "../configure/configure.js";
import Nav from "../Include/Nav";
import Footer from "../Include/footer";
import Menu from "../Include/Menu";
import loadjs from "loadjs";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import DataTable from "react-data-table-component";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";

const baseUrl = Url.baseUrl;
console.log('baseUrl = ' + baseUrl);
const $ = require("jquery");
const columns = [
  {
    dataField: "id",
    text: "Product ID",
  },
];

class Receive extends Component {
  constructor(props) {
    super(props);
    var accessToken = localStorage.getItem("token");
    this.state = {
      accessToken: accessToken,
      tabledata: "",
      respStatus: false,
      // startDate: new Date(),
      // endDate: new Date(),
      responsedData: [],
      html11: "",
      // q: "",
      upi: "",
      wAmount: "",
      account_holder : "", 
      account_number : "", 
      ifsc : "", 
      t_id : "", 
    };
    this.changeFormat = this.changeFormat.bind(this);
  }

  // handleChange111 = (date) => {
  //   this.setState({
  //     startDate: date,
  //   });
  // };
  // handleChange1 = (date) => {
  //   this.setState({
  //     endDate: date,
  //   });
  // };

  handleUPIChange = (event) => {
    this.setState({ upi: event.target.value });
  };
  handleHolderChange = (event) => {
    this.setState({ account_holder: event.target.value });
  };
  handleNumberChange = (event) => {
    this.setState({ account_number: event.target.value });
  };
  handleIfscChange = (event) => {
    this.setState({ ifsc: event.target.value });
  };
  handleWithdrawChange = (event) => {
    this.setState({ wAmount: event.target.value });
  };

  handleWithdraw = (event) => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    let sendData = {
      account_holder: this.state.account_holder,
      account_number: this.state.account_number,
      ifsc: this.state.ifsc,
      upi: this.state.upi,
      wAmount: this.state.wAmount,
      
    };
    console.log(sendData, headers);
    event.preventDefault();
    axios
      .post(baseUrl + "/withdraw", sendData, { headers })
      .then((resp) => {
        //this.handleModal("close");
        var respNew = resp.data;
          alert(respNew.message);
          window.location.reload();
      });
  };

  // handleSubmit = (event) => {
  //   let headers = {
  //     Authorization: "Bearer " + this.state.accessToken,
  //   };
  //   let sendData = {
  //     startDate: this.state.startDate,
  //     endDate: this.state.endDate,
  //     q: this.state.q,
  //   };
  //   event.preventDefault();
  //   axios
  //     .post(baseUrl + "/deposit_data", sendData, { headers })
  //     .then((resp) => {
  //       //this.handleModal("close");
  //       var respNew = resp.data;
  //       if (respNew.success === true) {
  //         this.setState({
  //           tabledata: respNew.showdata,
  //           respStatus: respNew.success,
  //         });
  //         this.changeFormat(respNew.showdata);
  //       } else {
  //         var newarry = [];

  //         this.changeFormat(newarry);
  //       }
  //     });
  // };

  componentWillMount() {
    // setting header
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios.get(baseUrl + "/withdraw_data", { headers }).then((resp) => {
      //this.handleModal("close");
      var respNew = resp.data;
      if (respNew.success === true) {
        this.setState({
          tabledata: respNew.showdata,
          respStatus: respNew.success,
        });
        this.changeFormat(respNew.showdata);
      } else {
        console.log("hello",newarry);
        var newarry = [];
        this.changeFormat(newarry);
      }
    });
  }

  changeFormat = (arr) => {
    console.log({ arr });
    let html = [];
    if (arr != "") {
      // console.log(this.state.tabledata);

      var newdata = arr;
      let amount = 0;
      let showdata = "";
      newdata.map(function (value, i) {
        if (value.status === 0) { showdata = "Accepted";}
        else if (value.status === 2) { showdata = "Rejected";}
        else{ showdata = "Pending";}
        let credit = "";
          amount = value.amount;
          credit =value.amount;
        var obj = {
          date: Moment(value.createdDate).format("lll"),
          s_no: i + 1,
          upi: value.upi_id.toUpperCase(),
          credit: credit && parseInt(credit).toFixed(0),
          status : showdata.toLowerCase(),
          remark: value.trans_type.toLowerCase(),
        };
        html.push(obj);
      });
      this.setState({ html11: html });
    } else {
      this.setState({ html11: [] });
    }
  };
  render() {
    var accessToken = this.state.accessToken;

    if (accessToken === "" || accessToken === null) {
      return <Redirect to="/login" />;
    }
    var change_password = localStorage.getItem("change_password");
    if (change_password != "" && change_password != null) {
      return <Redirect to="/change_password" />;
    }
    const data = "";

    console.log();
    return (
      <div>
        <div>
          <Nav />
          <Menu />
          <div id="wrapper">
            <ul className="sidebar navbar-nav">
              {/*<li className="nav-item all_sp">
							<span>All Sports</span>
	</li>*/}
              <li>
                <ul className="tree">
                  <li className="">
                    <a href="/4" style={{ color: "black" }}>
                      {" "}
                      Home
                    </a>
                  </li>
                  <li className="nav-item nav-link">
                    <a href="/4" style={{ color: "black" }}>
                      {" "}
                      Cricket
                    </a>
                  </li>
                  <li className="nav-item nav-link">
                    <a href="/2" style={{ color: "black" }}>
                      Tennis
                    </a>
                  </li>
                  <li className="nav-item nav-link">
                    <a href="/1" style={{ color: "black" }}>
                      Football
                    </a>
                  </li>
                  <li className="nav-item nav-link">
                    <a href="/7" style={{ color: "black" }}>
                      {" "}
                      Horse Riding
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div id="content-wrapper">
              <div className="container-fluid re_man_p0">
                <div className="card">
                  <div className="card-header breadcrumb">
                    Withdrawl Request
                  </div>
                  <div className="card-body">
                  <form onSubmit={this.handleWithdraw}>
                      <div className="row">
                      <div className="col-6 col-md-2">
                        <div className="form-group">
                          <input
                          className="form-control"
                          type="number"
                          placeholder="Enter amount"
                          name="amount"
                          value={this.state.wAmount}
                          onChange={this.handleWithdrawChange}
                          min="1"
                          max="99999999"
                          maxlength="9"
                          required=""
                        />
                        </div>
                        </div>
                        <div className="col-6 col-md-2">
                        <div className="form-group">
                          <input
                          className="form-control"
                          type="text"
                          value={this.state.upi}
                          onChange={this.handleUPIChange}
                          placeholder="Enter your UPI ID here"
                          name="upi"
                          required=""
                        />
                        </div>
                        </div>
                        <div className="col-6 col-md-2">
                        <div className="form-group">
                          <input
                          className="form-control"
                          type="text"
                          name="account_holder"
                          value={this.state.account_holder}
                          onChange={this.handleHolderChange}
                          placeholder="Enter your Account Holder name here"
                          required=""
                        />
                        </div>
                        </div>
                        <div className="col-6 col-md-2">
                        <div className="form-group">
                          <input
                          className="form-control"
                          type="text"
                          name="account_number"
                          value={this.state.account_number}
                          onChange={this.handleNumberChange}
                          placeholder="Enter your Account Number here"
                          required=""
                        />
                        </div>
                        </div>
                        <div className="col-6 col-md-2">
                        <div className="form-group">
                          <input
                          className="form-control"
                          type="text"
                          name="ifsc"
                          value={this.state.ifsc}
                          onChange={this.handleIfscChange}
                          placeholder="Enter your IFSC Code here"
                          required=""
                        />
                        </div>
                        </div>
                        <div className=" col-12 col-md-2">
                          <button
                            className="btn btn-primary modb"
                            value="withdraw"
                            type="submit"
                          >
                            Withdrawal Request
                          </button>
                        </div>
                      </div>
                    </form>
                    </div>
                    <div className="card-header breadcrumb">
                    Withdrawal Statement
                  </div>
                  <div className="card-body">
                    {/* <form onSubmit={this.handleSubmit}>
                      <div className="row">
                        <div className="col-6 col-md-2">
                          <div className="datepicker-wrapper form-group">
                            <DatePicker
                              selected={this.state.startDate}
                              onChange={this.handleChange111}
                            />
                            <i className="fas fa-calendar-alt"></i>
                          </div>
                        </div>
                        <div className=" col-md-111 re_none tc mt-2 ">
                          <span className="">to</span>
                        </div>
                        <div className="col-6 col-md-2">
                          <div className="datepicker-wrapper form-group">
                            <DatePicker
                              className="form-control"
                              selected={this.state.endDate}
                              onChange={this.handleChange1}
                            />
                            <i className="fas fa-calendar-alt"></i>
                          </div>
                        </div>
                        <div className="col-12 col-md-2">
                          <div className="select-report  form-group">
                            <select
                              id="bind_opt_select"
                              className="form-control"
                              name="q"
                              onChange={this.handleChange}
                            >
                              <option value="1" selected="selected">
                                All
                              </option>
                              <option value="2">
                                Deposite/Withdrow Report
                              </option>
                              <option value="3">Game Report</option>
                            </select>
                          </div>
                        </div>
                        <div className=" col-12 col-md-2">
                          <button
                            className="btn btn-primary modb"
                            value="submit"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form> */}
                    <div className="table-responsive rowp0 dot_table">
                      <div
                        id="account-statement_wrapper "
                        className="dataTables_wrapper "
                      >
                        <BootstrapTable
                          data={this.state.html11}
                          striped={true}
                          hover={true}
                          pagination
                          ignoreSinglePage
                          search
                          searchPlaceholder="input something..."
                        >
                          <TableHeaderColumn dataField="date" isKey={true}>
                            Date
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="s_no">
                            Sr No.
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="upi">
                            Account Details
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="t_id">
                            Transaction ID / UTR Number
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="credit">
                            Withdrawal Amount
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="status">
                            Status
                          </TableHeaderColumn>
                          {/* :FIXME: fix the column widhth according to device size */}
                          <TableHeaderColumn dataField="remark" width="100px">
                            Remark
                          </TableHeaderColumn>
                        </BootstrapTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Receive;



// WEBPACK FOOTER //
// ./src/components/Pages/withdrawl.js